import { useContext, useState, useEffect } from "react"; 
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
// import MDAlert from "components/MDAlert"; // Unused

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
// Overview page components
import Header from "./components/Header";
import ImageGalleryUpload from "./components/Gallery";

import { useMaterialUIController, AuthContext } from "context";
import { ProfileContext } from "context/profile";
import AuthService from "services/auth-service";
import HttpService from "services/htttp.service";

import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";
import Swal from "sweetalert2";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import InputMask from "react-input-mask";
import Joyride, { STATUS, EVENTS } from "react-joyride";

const brazilianStates = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", 
  "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"
];

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <MDBox sx={{ p: { xs: 0.5, md: 3 } }}>
          {children}
        </MDBox>
      )}
    </div>
  );
};

const Profile = () => {
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;

  const { user: authUser, setUser: setAuthUser } = useContext(AuthContext);
  const {
    profileImage, setProfileImage,
    images, setImages,
    galleryData, setGalleryData,
    setError, // error unused in this scope
    tabValue, setTabValue,
    user, setUser,
    biography, setBiography,
    profileUser, setProfileUser,
    contacts, setContacts,
    changeHandle
  } = useContext(ProfileContext);

  const [errors, setErrors] = useState({
    nameError: false,
    lastNameError: false,
    addressError: false,
    neighborhoodError: false,
    cityError: false,
    postalCodeError: false,
    stateError: false,
    countryError: false,
    emailError: false,
    newPassError: false,
    confirmPassError: false,
    artist_nameError: false,
  });

  const [bannerFile, setBannerFile] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [idsToDelete, setIdsToDelete] = useState([]);
  const [deleteBanner, setDeleteBanner] = useState(false);
  const [tags, setTags] = useState([]);
  const [currentTag, setCurrentTag] = useState("");
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);

  // States for Joyride Tour
  const [runTour, setRunTour] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const [tourSteps] = useState([
    {
      target: '#full-width-tab-0',
      content: 'Personalize seu perfil público: Foto, Nome Artístico, Redes Sociais, Banner e Galeria.',
      disableBeacon: true,
    },
    {
      target: '#full-width-tab-1',
      content: 'Gerencie seus dados pessoais, endereço e informações de contato.',
    },
    {
      target: '#full-width-tab-2',
      content: 'Controle a visibilidade do seu perfil no site (Ativar/Desativar).',
    },
    {
      target: '#full-width-tab-3',
      content: 'Segurança: Atualize sua senha de acesso ao sistema.',
    }
  ]);

  useEffect(() => {
    // Inicia o tour se ainda não foi visto
    if (authUser && !authUser.tours?.profile) {
      setRunTour(true);
    }
  }, [authUser]);

  const handleJoyrideCallback = (data) => {
    const { status, type, index, action } = data;

    if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      setStepIndex(index + (action === "prev" ? -1 : 1));
    } else if (type === EVENTS.TOUR_START) {
      setStepIndex(0);
    }

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRunTour(false);
      setStepIndex(0);
      HttpService.post("my-tours/profile");
      if (setAuthUser) {
        setAuthUser((prev) => ({
          ...prev,
          tours: { ...prev?.tours, profile: 1 },
        }));
      }
    }
  };

  useEffect(() => {
    if (user?.banner?.url) {
      setBannerPreview(user.banner.url);
    }
  }, [user]);

  const handleBannerChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBannerFile(file);
      setBannerPreview(URL.createObjectURL(file));
      setDeleteBanner(false);
    }
  };

  const handleBannerRemove = (e) => {
    e.stopPropagation();
    if (bannerFile) {
      setBannerFile(null);
      setBannerPreview(user?.banner?.url || null);
      setDeleteBanner(false);
    } else {
      setBannerPreview(null);
      setDeleteBanner(true);
    }
  };

  const handleGalleryRemove = (media) => {
    if (media.id) {
      setIdsToDelete((prev) => [...prev, media.id]);
      setGalleryData((prev) => prev.filter((m) => m.id !== media.id));
    } else {
      setImages((prev) => prev.filter((img) => img !== media));
    }
  };

  const getEmbedUrl = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) 
      ? `https://www.youtube.com/embed/${match[2]}` 
      : null;
  };

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const data = await AuthService.getProfile();
        if (data) {
          setUser((prev) => ({
            ...prev,
            ...data,
            address: data.address?.address || "",
            neighborhood: data.address?.neighborhood || "",
            city: data.address?.city || "",
            state: data.address?.state || "",
            postal_code: data.address?.postal_code || "",
            country: data.address?.country || "Brasil",
          }));

          if (data.galleryMedia) {
            const video = data.galleryMedia.find(m => m.type === 'youtube');
            if (video) setYoutubeUrl(video.url);
            setGalleryData(data.galleryMedia.filter((m) => m.type !== 'youtube'));
          }

          if (data.musicPreferences?.genre) {
            setTags(data.musicPreferences.genre.split(",").map((t) => t.trim()).filter((t) => t));
          }
        }
      } catch (err) {
        console.error("Failed to load profile data", err);
      }
    };
    loadProfile();
  }, [setUser]);

  useEffect(() => {
    let total = 0;
    let filled = 0;

    const check = (val) => {
      total++;
      if (val && String(val).trim().length > 0) filled++;
    };

    // 1. Foto (Avatar)
    total++;
    if ((profileImage && profileImage.image) || (user.media && user.media.url)) filled++;

    // 2. Nome Artístico
    check(user.artist_name);

    // 3. Bio
    total++;
    const cleanBio = biography ? biography.replace(/<[^>]*>?/gm, '').trim() : "";
    if (cleanBio.length > 0) filled++;

    // 4. Tags
    total++;
    if (tags.length > 0) filled++;

    // 5. Info Pessoal
    check(user.name);
    check(user.last_name);
    check(user.email);
    check(contacts.phone1);
    check(user.address);
    check(user.city);
    check(user.state);
    
    // 6. Galeria
    total++;
    if (galleryData.length > 0 || images.length > 0) filled++;

    // 7. Social & Links
    check(contacts.instagram);
    check(contacts.tiktok);
    check(contacts.twitter);
    check(contacts.site);
    check(youtubeUrl);

    const result = total === 0 ? 0 : Math.round((filled / total) * 100);
    setProgress(result);
  }, [user, biography, tags, profileImage, galleryData, images, contacts, youtubeUrl]);

  const handleTagAdd = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const val = currentTag.trim();
      if (val && !tags.includes(val)) {
        setTags([...tags, val]);
        setCurrentTag("");
      }
    }
  };

  const handleTagDelete = (tagToDelete) => {
    setTags(tags.filter((t) => t !== tagToDelete));
  };

  const handleUpload = (e) => {
    const files = Array.from(e.target.files);
    setImages((prevImages) => [...prevImages, ...files]);
  };

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  const handleVisibilityToggle = (e) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // Remove tags HTML do ReactQuill para verificar se há texto real
      const cleanBio = biography ? biography.replace(/<[^>]*>?/gm, '').trim() : "";
      // Verifica se tem imagem no contexto (upload pendente) ou no objeto user já salvo
      const hasPhoto = (profileImage && profileImage.image) || (user.media && user.media.url);
      const hasArtistName = user.artist_name && user.artist_name.trim().length > 0;

      if (!cleanBio || !hasPhoto || !hasArtistName) {
        Swal.fire({
          icon: "warning",
          title: "Perfil Incompleto",
          text: "Para tornar seu perfil visível, é necessário adicionar uma foto de perfil, preencher sua biografia e o nome artístico.",
        });
        setUser((prev) => ({ ...prev, is_visible: false }));
        return;
      }
    }

    setUser((prev) => ({ ...prev, is_visible: isChecked }));
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Limpar erros antes de validar
    setErrors({
      nameError: false,
      lastNameError: false,
      addressError: false,
      neighborhoodError: false,
      cityError: false,
      postalCodeError: false,
      stateError: false,
      countryError: false,
      emailError: false,
      artist_nameError: false,
      newPassError: false,
      confirmPassError: false,
    });

    let attributes = {};

    // validation
    const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    // Lógica separada por abas
    if (tabValue === 0) {
      // --- ABA 0: PERFIL ---
      if ((user.artist_name || "").trim().length === 0) {
        setErrors((prev) => ({ ...prev, artist_nameError: true }));
        Swal.fire({
          icon: "error",
          title: "Campos Obrigatórios",
          text: "Por favor, preencha o Nome do Artista.",
        });
        setLoading(false);
        return;
      }

      if (idsToDelete.length > 0) {
        try {
          await Promise.all(idsToDelete.map((id) => AuthService.deleteMedia(id)));
        } catch (error) {
          console.error("Erro ao excluir imagens:", error);
        }
      }

      if (deleteBanner && user?.banner?.id && !bannerFile) {
        try {
          await AuthService.deleteMedia(user.banner.id);
        } catch (error) {
          console.error("Erro ao excluir banner:", error);
        }
      }

      attributes = {
        artist_name: user.artist_name,
        site: contacts.site,
        tiktok: contacts.tiktok,
        twitter: contacts.twitter,
        instagram: contacts.instagram,
        bio_text: biography,
        genre: tags.join(","),
      };

      // Upload de Mídia (Imagem de Perfil e Galeria) apenas na aba Perfil
      const file = document.getElementById('profile-image-upload').files[0];
      if (file !== undefined) {
        const data = new FormData();
        data.append("images[]", file);
        data.append("purpose", profileImage.purpose);
        try {
          await AuthService.mediaUpload(data);
        } catch (uploadError) {
          console.error('Failed to upload profile image:', uploadError);
          setError('Failed to upload profile image.');
        }
      }

      if (bannerFile) {
        const bannerData = new FormData();
        bannerData.append("images[]", bannerFile);
        bannerData.append("purpose", "banner");
        try {
          await AuthService.mediaUpload(bannerData);
        } catch (error) {
          console.error("Erro ao enviar banner:", error);
        }
      }

      if (youtubeUrl) {
        const videoData = new FormData();
        videoData.append("youtube_url", youtubeUrl);
        videoData.append("purpose", "gallery");
        try {
          await AuthService.mediaUpload(videoData);
        } catch (error) {
          console.error("Erro ao salvar vídeo:", error);
        }
      }

      const sendImage = async (image) => {
        const formPayload = new FormData();
        formPayload.append("images[]", image);
        formPayload.append("purpose", "gallery");
        try {
          await AuthService.mediaUpload(formPayload);
        } catch (error) {
          console.error("Erro ao enviar imagem:", error);
        }
      };

      const galleryUploadPromises = images.map(async (image) => {
        if (image instanceof File) {
          return sendImage(image);
        }
      });
      await Promise.all(galleryUploadPromises);

    } else if (tabValue === 1) {
      // --- ABA 1: INFORMAÇÕES PESSOAIS ---
      let hasError = false;
      let newErrors = { ...errors };

      if ((user.name || "").trim().length === 0) {
        newErrors.nameError = true;
        hasError = true;
      }
      if ((user.last_name || "").trim().length === 0) {
        newErrors.lastNameError = true;
        hasError = true;
      }
      if ((user.email || "").trim().length === 0 || !(user.email || "").trim().match(mailFormat)) {
        newErrors.emailError = true;
        hasError = true;
      }
      if ((user.address || "").trim().length === 0) {
        newErrors.addressError = true;
        hasError = true;
      }
      if ((user.neighborhood || "").trim().length === 0) {
        newErrors.neighborhoodError = true;
        hasError = true;
      }
      if ((user.city || "").trim().length === 0) {
        newErrors.cityError = true;
        hasError = true;
      }
      if ((user.postal_code || "").trim().length === 0) {
        newErrors.postalCodeError = true;
        hasError = true;
      }
      if ((user.state || "").trim().length === 0) {
        newErrors.stateError = true;
        hasError = true;
      }
      if ((user.country || "").trim().length === 0) {
        newErrors.countryError = true;
        hasError = true;
      }

      if (hasError) {
        setErrors(newErrors);
        Swal.fire({
          icon: "error",
          title: "Campos Obrigatórios",
          text: "Por favor, preencha todos os campos obrigatórios em Informações Pessoais.",
        });
        setLoading(false);
        return;
      }

      attributes = {
        name: user.name,
        last_name: user.last_name,
        email: user.email,
        phone1: contacts.phone1,
        address: user.address,
        neighborhood: user.neighborhood,
        city: user.city,
        postal_code: user.postal_code,
        state: user.state,
        country: user.country,
      };

    } else if (tabValue === 2) {
      // --- ABA 2: VISIBILIDADE ---
      
      // Regra 3: Validar Foto e Biografia para tornar visível
      if (user.is_visible) {
        // Remove tags HTML do ReactQuill para verificar se há texto real
        const cleanBio = biography ? biography.replace(/<[^>]*>?/gm, '').trim() : "";
        // Verifica se tem imagem no contexto (upload pendente) ou no objeto user (já salvo)
        const hasPhoto = (profileImage && profileImage.image) || (user.media && user.media.url);
        const hasArtistName = user.artist_name && user.artist_name.trim().length > 0;

        if (!cleanBio || !hasPhoto || !hasArtistName) {
          Swal.fire({
            icon: "warning",
            title: "Perfil Incompleto",
            text: "Para tornar seu perfil visível, é necessário adicionar uma foto de perfil, preencher sua biografia e o nome artístico.",
          });
          setLoading(false);
          return;
        }
      }

      attributes = {
        is_visible: user.is_visible,
      };

    } else if (tabValue === 3) {
      // --- ABA 3: SEGURANÇA ---
      const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;

      if (!passwordRegex.test(user.newPassword)) {
        setErrors((prev) => ({ ...prev, newPassError: true }));
        Swal.fire({
          icon: "error",
          title: "Senha Inválida",
          text: "A senha deve ter pelo menos 8 caracteres, incluindo letras e números.",
        });
        setLoading(false);
        return;
      }

      if (user.newPassword !== user.confirmPassword) {
        setErrors((prev) => ({ ...prev, confirmPassError: true }));
        Swal.fire({
          icon: "error",
          title: "Senhas não conferem",
          text: "A confirmação de senha não corresponde à nova senha.",
        });
        setLoading(false);
        return;
      }

      attributes = {
        password: user.newPassword,
      };
    }

    let userData = {
      data: {
        type: "profile",
        attributes: attributes,
      },
    };

    try {
      await AuthService.updateProfile(userData); // Removed unused 'response'

      if (tabValue === 3) {
        setUser({
          ...user,
          newPassword: "",
          confirmPassword: ""
        });
      }

      Swal.fire({
        icon: "success",
        title: "Sucesso",
        text: "Perfil atualizado com sucesso!",
        timer: 2000,
        showConfirmButton: false,
      });

      const updatedUser = await AuthService.getProfile();

      setProfileUser({
        profile_name: updatedUser.name,
        profile_artist_name: updatedUser.artist_name,
      });

      if (updatedUser.media && updatedUser.media.url) {
        setProfileImage({
          image: updatedUser.media.url,
          purpose: "profile",
        });
      }

    } catch (error) {
      console.error("Failed to update profile:", error);

      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível atualizar o perfil. Tente novamente.",
      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <DashboardLayout>
      <Joyride
        steps={tourSteps}
        run={runTour}
        stepIndex={stepIndex}
        continuous
        showSkipButton
        showProgress={false}
        callback={handleJoyrideCallback}
        styles={{
          options: {
            zIndex: 10000,
            primaryColor: sidenavColor === 'default' ? '#1A73E8' : 'var(--mui-palette-' + sidenavColor + '-main, #1A73E8)',
          },
        }}
        locale={{
          back: 'Voltar',
          close: 'Fechar',
          last: 'Entendi',
          next: 'Próximo',
          skip: 'Pular'
        }}
      />
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header
        name={profileUser.profile_artist_name ? profileUser.profile_artist_name : profileUser.profile_name}
        tabValue={tabValue}
        handleSetTabValue={handleSetTabValue}
        progress={progress}
      >

        {/* --- TAB 0: PERFIL --- */}
        <TabPanel value={tabValue} index={0}>
          <MDBox
            component="form"
            role="form"
            onSubmit={submitHandler}
            display="flex"
            flexDirection="column"
            encType="multipart/form-data"
          >
            <MDBox display="flex" flexDirection={{ xs: "column", md: "row" }} mt={5} mb={3}>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                mr={{ xs: 0, md: 2 }}
                mb={{ xs: 2, md: 0 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Nome do Artista
                </MDTypography>
                <MDBox mb={2} width="100%">
                  <MDInput
                    type="name"
                    fullWidth
                    name="artist_name"
                    value={user.artist_name || ""}
                    onChange={changeHandle(user, setUser)}
                    error={errors.artist_nameError}
                  />
                  {errors.artist_nameError && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      O nome artístico é obrigatório
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                ml={{ xs: 0, md: 2 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Site na internet
                </MDTypography>
                <MDBox mb={1} width="100%">
                  <MDInput
                    type="text"
                    fullWidth
                    name="site"
                    value={contacts.site}
                    onChange={changeHandle(contacts, setContacts)}
                    disabled={false}
                  />
                </MDBox>
              </MDBox>
            </MDBox>

            <MDBox mb={3}>
              <MDTypography>
                Redes Sociais
              </MDTypography>
            </MDBox>

            <MDBox display="flex" flexDirection={{ xs: "column", md: "row" }} mt={0} mb={3}>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                mr={{ xs: 0, md: 2 }}
                mb={{ xs: 2, md: 0 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  TikTok
                </MDTypography>
                <MDBox mb={2} width="100%">
                  <MDInput
                    type="name"
                    fullWidth
                    name="tiktok"
                    value={contacts.tiktok}
                    onChange={changeHandle(contacts, setContacts)}
                    disabled={false}
                  />
                </MDBox>
              </MDBox>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                ml={{ xs: 0, md: 2 }}
                mr={{ xs: 0, md: 2 }}
                mb={{ xs: 2, md: 0 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Twitter
                </MDTypography>
                <MDBox mb={1} width="100%">
                  <MDInput
                    type="name"
                    fullWidth
                    name="twitter"
                    value={contacts.twitter}
                    onChange={changeHandle(contacts, setContacts)}
                    disabled={false}
                  />
                </MDBox>
              </MDBox>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                ml={{ xs: 0, md: 2 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Instagram
                </MDTypography>
                <MDBox mb={1} width="100%">
                  <MDInput
                    type="name"
                    fullWidth
                    name="instagram"
                    value={contacts.instagram}
                    onChange={changeHandle(contacts, setContacts)}
                    disabled={false}
                  />
                </MDBox>
              </MDBox>
            </MDBox>
            <MDBox mb={3} width="100%">
              <MDTypography mb={2}>
                Banner
              </MDTypography>
              <MDBox
                onClick={() => document.getElementById("banner-upload").click()}
                sx={{
                  border: "2px dashed",
                  borderColor: darkMode ? "rgba(255, 255, 255, 0.3)" : "rgba(0, 0, 0, 0.1)",
                  borderRadius: "1rem",
                  height: "250px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  overflow: "hidden",
                  position: "relative",
                  backgroundColor: darkMode ? "#1a2035" : "#f8f9fa",
                  backgroundImage: bannerPreview ? `url(${bannerPreview})` : "none",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                {bannerPreview && (
                  <MDBox
                    onClick={handleBannerRemove}
                    sx={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      zIndex: 10,
                      cursor: "pointer",
                      backgroundColor: "rgba(255, 255, 255, 0.8)",
                      borderRadius: "50%",
                      padding: "4px",
                      display: "flex",
                    }}
                  >
                    <Icon color="error">delete</Icon>
                  </MDBox>
                )}
                {!bannerPreview && (
                  <Icon fontSize="large" color="secondary">add</Icon>
                )}
                <input
                  type="file"
                  id="banner-upload"
                  hidden
                  accept="image/*"
                  onChange={handleBannerChange}
                />
              </MDBox>
            </MDBox>

            <MDBox mb={3} width="100%">
              <MDTypography mb={2}>
                Galeria
              </MDTypography>
              <ImageGalleryUpload
                images={images}
                galleryData={galleryData}
                setGalleryData={setGalleryData}
                handleUpload={handleUpload}
                onRemove={handleGalleryRemove}
              />
            </MDBox>
            <MDBox mb={3} width="100%">
              <MDTypography mb={2}>
                Vídeo do Youtube
              </MDTypography>
              <MDBox mb={2}>
                <MDInput
                  type="text"
                  label="Link do Youtube"
                  fullWidth
                  value={youtubeUrl}
                  onChange={(e) => setYoutubeUrl(e.target.value)}
                />
              </MDBox>

              {youtubeUrl && getEmbedUrl(youtubeUrl) && (
                <MDBox sx={{ width: "100%", maxWidth: "500px", height: "300px", borderRadius: "8px", overflow: "hidden", position: "relative" }}>
                  <iframe
                    width="100%"
                    height="100%"
                    src={getEmbedUrl(youtubeUrl)}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </MDBox>
              )}
            </MDBox>

            <MDBox mb={3} width="100%">
              <MDTypography mb={2}>
                Tags Musicais
              </MDTypography>
              <MDBox mb={2}>
                <MDInput
                  type="text"
                  label="Adicionar Tag (Enter)"
                  fullWidth
                  value={currentTag}
                  onChange={(e) => setCurrentTag(e.target.value)}
                  onKeyDown={handleTagAdd}
                />
              </MDBox>
              <MDBox display="flex" flexWrap="wrap" gap={1}>
                {tags.map((tag, index) => (
                  <Chip key={index} label={tag} onDelete={() => handleTagDelete(tag)} />
                ))}
              </MDBox>
            </MDBox>
            <MDBox display="flex" flexDirection="row" mt={5} mb={3}>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                mr={{ xs: 0, md: 2 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Biografia
                </MDTypography>
                <MDBox mb={1} width="100%">
                  <MDBox sx={{
                    "& .ql-toolbar": {
                      backgroundColor: darkMode ? "#f0f2f5" : "#fff",
                      borderRadius: "0.5rem 0.5rem 0 0",
                    },
                    "& .ql-container": {
                      backgroundColor: darkMode ? "transparent" : "#fff",
                      color: darkMode ? "#fff" : "inherit",
                      borderRadius: "0 0 0.5rem 0.5rem",
                    }
                  }}>
                    <ReactQuill
                      theme="snow"
                      value={biography}
                      onChange={setBiography}
                      placeholder="Escreva sua biografia..."
                    />
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton type="submit" variant="gradient" color={sidenavColor} disabled={loading}>
                {loading ? "Processando..." : "Atualizar"}
              </MDButton>
            </MDBox>
          </MDBox>
        </TabPanel>

        {/* --- TAB 1: INFO PESSOAL --- */}
        <TabPanel value={tabValue} index={1}>
          <MDBox
            component="form"
            role="form"
            onSubmit={submitHandler}
            display="flex"
            flexDirection="column"
          >
            <MDBox display="flex" flexDirection={{ xs: "column", md: "row" }} mt={5} mb={3}>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                mr={{ xs: 0, md: 2 }}
                mb={{ xs: 2, md: 0 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Nome
                </MDTypography>
                <MDBox mb={2} width="100%">
                  <MDInput
                    type="name"
                    fullWidth
                    name="name"
                    value={user.name}
                    onChange={changeHandle(user, setUser)}
                    error={errors.nameError}
                  />
                  {errors.nameError && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      O nome é obrigatório
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                ml={{ xs: 0, md: 2 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Sobrenome
                </MDTypography>
                <MDBox mb={1} width="100%">
                  <MDInput
                    type="name"
                    fullWidth
                    name="last_name"
                    value={user.last_name}
                    onChange={changeHandle(user, setUser)}
                    error={errors.lastNameError}
                  />
                  {errors.lastNameError && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      O sobrenome é obrigatório
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
            </MDBox>

            <MDBox display="flex" flexDirection={{ xs: "column", md: "row" }} mt={0} mb={3}>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                mr={{ xs: 0, md: 2 }}
                mb={{ xs: 2, md: 0 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Telefone
                </MDTypography>
                <MDBox mb={2} width="100%">
                  <InputMask
                    mask="(99) 99999-9999"
                    value={contacts.phone1 || ""}
                    onChange={changeHandle(contacts, setContacts)}
                    disabled={false}
                  >
                    {(inputProps) => (
                      <MDInput {...inputProps} type="tel" fullWidth name="phone1" />
                    )}
                  </InputMask>
                </MDBox>
              </MDBox>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                ml={{ xs: 0, md: 2 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  E-mail
                </MDTypography>
                <MDBox mb={1} width="100%">
                  <MDInput
                    type="email"
                    fullWidth
                    name="email"
                    value={user.email}
                    onChange={changeHandle(user, setUser)}
                    error={errors.emailError}
                    disabled={false}
                  />
                  {errors.emailError && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      O email deve ser válido
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
            </MDBox>

            <MDBox display="flex" flexDirection="column" mb={3}>
              <MDBox display="flex" flexDirection={{ xs: "column", md: "row" }}>
                <MDBox
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                  width="100%"
                  mr={{ xs: 0, md: 2 }}
                  mb={{ xs: 2, md: 0 }}
                >
                  <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                    Endereço
                  </MDTypography>
                  <MDBox mb={2} width="100%">
                    <MDInput
                      type="name"
                      fullWidth
                      name="address"
                      value={user.address || ""}
                      onChange={changeHandle(user, setUser)}
                      error={errors.addressError}
                    />
                    {errors.addressError && (
                      <MDTypography variant="caption" color="error" fontWeight="light">
                        Endereço é um campo obrigatório
                      </MDTypography>
                    )}
                  </MDBox>
                </MDBox>
                <MDBox
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                  width="100%"
                  ml={{ xs: 0, md: 2 }}
                >
                  <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                    Bairro
                  </MDTypography>
                  <MDBox mb={1} width="100%">
                    <MDInput
                      type="name"
                      fullWidth
                      name="neighborhood"
                      value={user.neighborhood || ""}
                      onChange={changeHandle(user, setUser)}
                      error={errors.neighborhoodError}
                    />
                    {errors.neighborhoodError && (
                      <MDTypography variant="caption" color="error" fontWeight="light">
                        Bairro é um campo obrigatório
                      </MDTypography>
                    )}
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDBox>

            <MDBox display="flex" flexDirection={{ xs: "column", md: "row" }} mt={0} mb={3}>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                mr={{ xs: 0, md: 2 }}
                mb={{ xs: 2, md: 0 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Cidade
                </MDTypography>
                <MDBox mb={1} width="100%">
                  <MDInput
                    type="name"
                    fullWidth
                    name="city"
                    value={user.city}
                    onChange={changeHandle(user, setUser)}
                    error={errors.cityError}
                  />
                  {errors.cityError && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      Cidade é um campo obrigatório
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                ml={{ xs: 0, md: 2 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Cep
                </MDTypography>
                <MDBox mb={2} width="100%">
                  <MDInput
                    type="name"
                    fullWidth
                    name="postal_code"
                    value={user.postal_code}
                    onChange={changeHandle(user, setUser)}
                    error={errors.postalCodeError}
                    disabled={false}
                  />
                  {errors.postalCodeError && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      Cep é um campo obrigatório
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
            </MDBox>

            <MDBox display="flex" flexDirection={{ xs: "column", md: "row" }} mt={0} mb={3}>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                mr={{ xs: 0, md: 2 }}
                mb={{ xs: 2, md: 0 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Estado
                </MDTypography>
                <MDBox mb={1} width="100%">
                  <MDInput
                    select
                    fullWidth
                    name="state"
                    value={user.state || ""}
                    onChange={changeHandle(user, setUser)}
                    SelectProps={{ native: true }}
                    error={errors.stateError}
                    disabled={false}
                  >
                    <option value="" style={{ color: darkMode ? "#fff" : "#000", backgroundColor: darkMode ? "#1a2035" : "#fff" }}>Selecione</option>
                    {brazilianStates.map((uf) => (
                      <option key={uf} value={uf} style={{ color: darkMode ? "#fff" : "#000", backgroundColor: darkMode ? "#1a2035" : "#fff" }}>{uf}</option>
                    ))}
                  </MDInput>
                  {errors.stateError && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      Estado é um campo obrigatório
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                ml={{ xs: 0, md: 2 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  País
                </MDTypography>
                <MDBox mb={1} width="100%">
                  <MDInput
                    type="name"
                    fullWidth
                    name="country"
                    value={user.country}
                    onChange={changeHandle(user, setUser)}
                    error={errors.countryError}
                    disabled={false}
                  />
                  {errors.countryError && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      País é um campo obrigatório
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton type="submit" variant="gradient" color={sidenavColor} disabled={loading}>
                {loading ? "Processando..." : "Atualizar"}
              </MDButton>
            </MDBox>
          </MDBox>
        </TabPanel>

        {/* --- TAB 2: VISIBILIDADE (CORRIGIDO) --- */}
        <TabPanel value={tabValue} index={2}>
          <MDBox
            component="form"
            role="form"
            onSubmit={submitHandler}
            display="flex"
            flexDirection="column"
          >
            <MDBox mb={3}>
              <MDTypography variant="h6">Visibilidade do Perfil</MDTypography>
              <MDBox display="flex" alignItems="center" mt={1}>
                <MDTypography variant="body2" mr={2}>
                  Exibir meu perfil no site
                </MDTypography>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(user.is_visible)}
                      onChange={handleVisibilityToggle}
                    />
                  }
                  label="Perfil visível"
                />
              </MDBox>
            </MDBox>
            <MDBox display="flex" justifyContent="flex-end">
              <MDButton type="submit" variant="gradient" color={sidenavColor} disabled={loading}>
                {loading ? "Processando..." : "Atualizar"}
              </MDButton>
            </MDBox>
          </MDBox>
        </TabPanel>

        {/* --- TAB 3: SEGURANÇA --- */}
        <TabPanel value={tabValue} index={3}>
          <MDBox
            component="form"
            role="form"
            onSubmit={submitHandler}
            display="flex"
            flexDirection="column"
          >
            <MDBox mb={3}>
              <MDTypography variant="h6">Segurança e Login</MDTypography>
            </MDBox>
            <MDBox display="flex" flexDirection={{ xs: "column", md: "row" }} mt={2} mb={3}>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                mr={{ xs: 0, md: 2 }}
                mb={{ xs: 2, md: 0 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Nova Senha
                </MDTypography>
                <MDBox mb={2} width="100%">
                  <MDInput
                    type="password"
                    fullWidth
                    name="newPassword"
                    placeholder="New Password"
                    value={user.newPassword}
                    onChange={changeHandle(user, setUser)}
                    error={errors.newPassError}
                    disabled={false}
                    inputProps={{
                      autoComplete: "new-password",
                      form: {
                        autoComplete: "off",
                      },
                    }}
                  />
                  {errors.newPassError && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      A senha deve ter pelo menos 8 caracteres, incluindo letras e números.
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                width="100%"
                ml={{ xs: 0, md: 2 }}
              >
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Confirme sua Senha
                </MDTypography>
                <MDBox mb={1} width="100%">
                  <MDInput
                    type="password"
                    fullWidth
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={user.confirmPassword}
                    onChange={changeHandle(user, setUser)}
                    error={errors.confirmPassError}
                    disabled={false}
                    inputProps={{
                      autoComplete: "confirm-password",
                      form: {
                        autoComplete: "off",
                      },
                    }}
                  />
                  {errors.confirmPassError && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      As senhas não conferem
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
            </MDBox>
            <MDBox display="flex" justifyContent="flex-end">
              <MDButton type="submit" variant="gradient" color={sidenavColor} disabled={loading}>
                {loading ? "Processando..." : "Atualizar"}
              </MDButton>
            </MDBox>
          </MDBox>
        </TabPanel>

      </Header>
      <Footer />
    </DashboardLayout>
  );
};

export default Profile;